/* Evento Arc'teryx × VIETTI — Sylan 2 Community Trail Run (issue #192).
 *
 * Gestisce i due moduli dell'evento (richiesta e dati finali): entrambi
 * scrivono direttamente su Klaviyo tramite la client API di sottoscrizione
 * (stessa chiave pubblica/company_id dell'app embed già attiva sul tema).
 * Nessun dato passa da Shopify: i campi diventano proprietà del profilo
 * Klaviyo e il profilo viene iscritto alla lista indicata nel setting
 * della sezione (vuoto finché le liste non esistono: in quel caso il
 * profilo viene comunque creato/aggiornato, senza lista).
 *
 * Anti-spam: honeypot (campo nascosto "sylan2_website") — se compilato,
 * il modulo finge l'invio riuscito senza chiamare Klaviyo.
 *
 * 11/09/2026 (ordine data unica, sabato 19/09): rimossa la logica delle
 * card «data preferita» (scelta multipla + card «qualsiasi data»): la
 * proprietà sylan2_preferred_date non viene più inviata.
 *
 * Scelta dell'endpoint (verificata con collaudo del 31/08/2026):
 * /client/subscriptions/ RICHIEDE la relazione list → si usa solo quando
 * il list ID è configurato nel setting della sezione; senza list ID il
 * modulo usa /client/profiles/ (crea/aggiorna il profilo con le stesse
 * proprietà, senza iscrizione a liste).
 */
(function () {
  'use strict';

  var KLAVIYO_SUBSCRIPTIONS = 'https://a.klaviyo.com/client/subscriptions/';
  var KLAVIYO_PROFILES = 'https://a.klaviyo.com/client/profiles/';
  var KLAVIYO_REVISION = '2025-04-15';

  function prefillEmail(form) {
    var input = form.querySelector('input[data-sylan-prefill-email]');
    if (!input) return;
    try {
      var params = new URLSearchParams(window.location.search);
      var email = params.get('email') || params.get('e');
      if (email) input.value = email;
    } catch (err) { /* URL senza parametri: nessun prefill */ }
  }

  function buildProfile(form) {
    var attributes = { properties: {} };
    var multi = {};
    var fields = form.querySelectorAll('[data-sylan-field]');
    fields.forEach(function (field) {
      var key = field.getAttribute('data-sylan-field');
      var value;
      if (field.type === 'radio') {
        // Card a scelta singola: conta solo la radio selezionata.
        if (!field.checked) return;
        value = field.value;
      } else if (field.type === 'checkbox' && field.hasAttribute('data-sylan-multi')) {
        // Checkbox a scelta multipla con la stessa proprietà: elenco
        // separato da virgole (usato fino al 10/09 per le date preferite;
        // dal 11/09 l'evento ha data unica e nessun campo lo usa, la
        // logica resta generica per eventuali campi futuri).
        if (!field.checked) return;
        if (!multi[key]) multi[key] = [];
        multi[key].push(field.value);
        return;
      } else if (field.type === 'checkbox') {
        value = field.checked ? 'yes' : 'no';
      } else {
        value = (field.value || '').trim();
      }
      if (value === '') return;
      if (key === 'email' || key === 'first_name' || key === 'last_name') {
        attributes[key] = value;
      } else if (key === 'city') {
        attributes.location = attributes.location || {};
        attributes.location.city = value;
        attributes.properties.sylan2_city = value;
      } else {
        attributes.properties[key] = value;
      }
    });
    Object.keys(multi).forEach(function (key) {
      attributes.properties[key] = multi[key].join(',');
    });
    return attributes;
  }

  function showError(root, message) {
    var box = root.querySelector('.sylan-form__error');
    if (!box) return;
    if (message) box.textContent = message;
    box.classList.add('is-visible');
  }

  function hideError(root) {
    var box = root.querySelector('.sylan-form__error');
    if (box) box.classList.remove('is-visible');
  }

  function succeed(root, form) {
    var redirect = form.getAttribute('data-sylan-redirect');
    if (redirect) {
      window.location.assign(redirect);
      return;
    }
    root.classList.add('is-sent');
    var success = root.querySelector('.sylan-form__success');
    if (success) {
      success.classList.add('is-visible');
      success.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function submitForm(root, form) {
    hideError(root);

    // Honeypot: i bot compilano tutto, gli umani non vedono il campo.
    var honeypot = form.querySelector('input[name="sylan2_website"]');
    if (honeypot && honeypot.value !== '') {
      succeed(root, form);
      return;
    }

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    var companyId = form.getAttribute('data-sylan-company-id');
    if (!companyId) {
      showError(root, form.getAttribute('data-sylan-error-config') || 'Configurazione mancante.');
      return;
    }

    var attributes = buildProfile(form);
    var stampKey = form.getAttribute('data-sylan-stamp') || 'sylan2_request_at';
    attributes.properties[stampKey] = new Date().toISOString();
    if (document.documentElement.lang) {
      attributes.properties.sylan2_locale = document.documentElement.lang;
    }

    var listId = form.getAttribute('data-sylan-list-id');
    var endpoint;
    var payload;
    if (listId) {
      endpoint = KLAVIYO_SUBSCRIPTIONS;
      payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: form.getAttribute('data-sylan-source') || 'Sylan 2',
            profile: { data: { type: 'profile', attributes: attributes } }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      };
    } else {
      endpoint = KLAVIYO_PROFILES;
      payload = { data: { type: 'profile', attributes: attributes } };
    }

    var button = form.querySelector('button[type="submit"]');
    if (button) button.disabled = true;

    fetch(endpoint + '?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'revision': KLAVIYO_REVISION
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        if (response.status === 202 || response.ok) {
          succeed(root, form);
          return;
        }
        return response.json().catch(function () { return null; }).then(function () {
          showError(root);
          if (button) button.disabled = false;
        });
      })
      .catch(function () {
        showError(root);
        if (button) button.disabled = false;
      });
  }

  function init() {
    document.querySelectorAll('[data-sylan-form]').forEach(function (root) {
      var form = root.querySelector('form');
      if (!form) return;
      prefillEmail(form);
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        submitForm(root, form);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
